import React from 'react';

import { useRouter } from 'next/router';

import {
  ListItem,
  ListItemButton,
  ListItemText,
  Typography,
} from '@mui/material';

import { AuthContext } from '@kamernet/core/Auth/AuthContext';
import { useIntl } from '@kamernet/core/Intl';
import { Locale } from '@kamernet/core/Intl/types';
import { ROUTES } from '@kamernet/core/Routing';

import styles from './Content.module.css';

export const SignUpButton = () => {
  const { locale } = useIntl();
  const router = useRouter();
  const { isAuthenticated } = AuthContext.useContext();

  const clickHandler = React.useCallback(() => {
    router.push(ROUTES.Signup.url({}, locale)).catch(() => {
      // ignore
    });
  }, [locale, router]);

  return isAuthenticated ? null : (
    <React.Fragment>
      <ListItemButton className={styles.listItem} onClick={clickHandler}>
        <ListItemText
          primary={
            <Typography color="primary">
              {locale === Locale.en
                ? 'Visit sign up page'
                : 'Bezoek de aanmeldpagina'}
            </Typography>
          }
        />
      </ListItemButton>
      <ListItem className={styles.listItem}>
        <ListItemText
          primary={
            locale === Locale.en
              ? 'Create an account by entering your email address'
              : 'Maak een account aan door je e-mailadres in te vullen'
          }
        />
      </ListItem>
    </React.Fragment>
  );
};
